import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';

function TenantWrapper() {
  const { company } = useParams();
  useEffect(() => {
    document.body.classList.remove('titan', 'gt');

    if (company === 'titan') {
      document.body.classList.add('titan');
    } else if (company === 'gt') {
      document.body.classList.add('gt');
    } else {
      document.body.classList.add('default-company');
    }
    return () => {
      document.body.classList.remove('titan', 'gt', 'default-brand');
    };
  }, [company]);
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default TenantWrapper;
